/*************************************/
/** 								**/
/**    COMPONENT REGISTRY	 		**/
/** 								**/
/*************************************/
hrd.core.ComponentRegistry = hrd.Class.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.core.ComponentRegistry',
			verbose: false
		};
		this._super($.extend(true, {}, defaults, options));
		this.repo = {};
	},
	register: function(type, mode, componentClass) {
		this.repo[this.toKey(type, mode)] = {component: componentClass};
	},
	retrieveClass: function(type, mode) {
		mode = mode || 'edit';
		let key = this.toKey(type, mode);
		let componentClass = this.repo[key];
		if(componentClass) {
			return componentClass;
		} else {
			if(this.settings.verbose) {
				console.log(`Component of type "${type}" form mode "${mode}" not yet implemented`);
			}
			return undefined; // here goes empty implementation?
		}
	},
	toKey: function(type, mode) {
		return `${type}-${mode}`;
	}
});

componentRegistryInstance = new hrd.core.ComponentRegistry();

